import logo from "./logo.svg";
import "./App.css";
import Routers from "./routers";

function App() {
  return <Routers />;
}

export default App;
